import { useAppThunkDispatch } from '../../state/store';
import { useSelector } from 'react-redux';
import {
  cancelCardChanges,
  cardSelectors,
  saveDashboardCardChanges,
} from '../../state/normalized/dashboard/cardSlice';
import React, { useCallback, useContext, useState } from 'react';
import { Button } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { DashboardContext } from './DashboardContext';
import UnsavedChangesPrompt from '../../Organisms/UnsavedChangesPrompt/UnsavedChangesPrompt';
import { PATHS } from 'utils/constants';

const DASHBOARD_ALLOWED_PATHS = [
  PATHS.DASHBOARD_DRILLDOWN_PAGE,
  PATHS.DASHBOARD_DETAIL_PAGE,
];

export const DashboardSaveControls = () => {
  const dispatch = useAppThunkDispatch();
  const [isSaving, setIsSaving] = useState(false);
  const { dashboardId } = useContext(DashboardContext);
  const hasUnsavedChanges = useSelector(cardSelectors.selectHasUnsavedChanges);

  const handleCancel = useCallback(() => {
    if (!hasUnsavedChanges || isSaving) return;
    dispatch(cancelCardChanges());
  }, [dispatch, hasUnsavedChanges, isSaving]);

  const handleSave = useCallback(async () => {
    if (!hasUnsavedChanges || isSaving) return;
    setIsSaving(true);
    try {
      await dispatch(saveDashboardCardChanges({ dashboardId })).unwrap();
    } finally {
      setIsSaving(false);
    }
  }, [dispatch, dashboardId, hasUnsavedChanges, isSaving]);

  return (
    <>
      <UnsavedChangesPrompt
        hasChanges={hasUnsavedChanges}
        allowedPaths={DASHBOARD_ALLOWED_PATHS}
        title={intl.get('UNSAVED_CHANGES_DASHBOARD_MODAL.TITLE')}
        message={intl.get('UNSAVED_CHANGES_DASHBOARD_MODAL.MESSAGE')}
        confirmButtonText={intl.get(
          'UNSAVED_CHANGES_DASHBOARD_MODAL.CONFIRM_BUTTON'
        )}
        cancelButtonText={intl.get(
          'UNSAVED_CHANGES_DASHBOARD_MODAL.CANCEL_BUTTON'
        )}
      />
      <div className='flex gap-x-2'>
        <>
          <Button
            variant='secondary'
            onClick={handleCancel}
            disabled={!hasUnsavedChanges || isSaving}
            data-cy='discard-dashboard-button'
          >
            {intl.get('SIDE_PANEL.CANCEL_BUTTON')}
          </Button>
          <Button
            onClick={handleSave}
            disabled={!hasUnsavedChanges || isSaving}
            data-cy='save-dashboard-button'
          >
            {intl.get('DASHBOARD_DETAIL_PAGE.SAVE_CHANGES_BUTTON')}
          </Button>
        </>
      </div>
    </>
  );
};
